import React from 'react';
import { useTranslation } from "react-i18next";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '../../ui/sheet';
import { HelpCenterSettings } from './HelpCenterSettings';

interface HelpCenterSettingsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  helpCenterId: number | string | null;
  onSuccess?: () => void;
}

export const HelpCenterSettingsDrawer: React.FC<HelpCenterSettingsDrawerProps> = ({
  isOpen,
  onClose,
  helpCenterId,
  onSuccess,
}) => {
  const { t } = useTranslation();
  if (!helpCenterId) {
    return null;
  }

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full sm:max-w-2xl overflow-y-auto">
        <SheetHeader>
          <SheetTitle>{t('helpCenter.settingsDrawer.title')}</SheetTitle>
          <SheetDescription>
            {t('helpCenter.settingsDrawer.description')}
          </SheetDescription>
        </SheetHeader>
        <div className="mt-6">
          <HelpCenterSettings
            helpCenterId={helpCenterId}
            onSuccess={() => {
              if (onSuccess) {
                onSuccess();
              }
            }}
            onClose={onClose}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};

